<div class="form-row">
  <div class="form-group col-md-12">
    <label>Question</label>
    <input type='text' name='checkInformation' [(ngModel)]='this.question.checkInformation' [class.is-invalid]='!this.question.checkInformation' class="form-control" placeholder="e.g. Tyre tread depth and condition">
  </div>
</div>

<div class="form-row">
  <div class="form-group col-md-4">
    <label>Check Area</label>
    <ng-select [(ngModel)]="this.question.vehicleCheckAreaId" class='form-control' [class.is-invalid]='this.question.vehicleCheckAreaId === -1'
      (change)='this.question.vehicleCheckAreaId = +$event'>
      @for (item of this.checkAreas; track item) {
        <ng-option [value]='item.id'>{{ item.name }}</ng-option>
      }
    </ng-select>
  </div>
  <div class="form-group col-md-4">
    <label>Severity if failed</label>
    <ng-select [(ngModel)]="this.question.severity" class='form-control' [class.is-invalid]='this.question.severity === -1'
      (change)='this.question.severity = +$event'>
      @for (item of this.severities; track item) {
        <ng-option [value]='item.id'>{{ item.notes }}</ng-option>
      }
    </ng-select>
  </div>
  <div class="form-group col-md-4">
    <label>Applies to Vehicle Type</label>
    <ng-select [(ngModel)]="this.question.vehicleTypeId" class='form-control'
      (change)='this.question.vehicleTypeId = +$event'>
      @for (item of this.vehicleTypes; track item) {
        <ng-option [value]='item.id'>{{ item.name }}</ng-option>
      }
    </ng-select>
  </div>
</div>

<div class='form-row'>
  <div class="form-group col-md-4">
    <div class='form-check'>
      <input type='checkbox' name='isVor' [(ngModel)]='this.question.isVor' class='form-check-input' id='isVor'>
      <label class='form-check-label' for='isVor'>Failing this takes the vehicle off road (VOR)</label>
    </div>
  </div>
  <div class="form-group col-md-4">
    <div class='form-check'>
      <input type='checkbox' name='active' [(ngModel)]='this.question.active' class='form-check-input' id='active'>
      <label class='form-check-label' for='active'>Active - shown to drivers</label>
    </div>
  </div>
</div>
